export default __webpack_public_path__ + "assets/webgl/texture1.ec702d03.jpg";